import { HttpParams } from '@angular/common/http';
import { IListFilter } from '@app/api/interfaces/common/list-filter';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateHttpParams(paramsObject: Record<string, any>, params: HttpParams): HttpParams {
  for (const key in paramsObject) {
    if (Object.prototype.hasOwnProperty.call(paramsObject, key) && (paramsObject[key] === 0 || !!paramsObject[key])) {
      const value = Array.isArray(paramsObject[key]) ? paramsObject[key].join(',') : paramsObject[key];
      params = params.append(key, value);
    }
  }

  return params;
}

/**
 * @description create HttpParams object for angular httpClient
 *
 *
 * @example
 * const paramsExample = {
 *    limit: 100,
 *    offset: 200,
 *    companyId: 'someId'
 *    status: ['done', 'updated']
 * }
 *
 * const params = generateHttpParams(paramsExample);
 *
 * this.httpClient.get(`${environment.apiBaseUrl}/v1/someRealEndpoint`, {params})
 *
 * // as result Get request with query params `?limit=100&offset=200&companyId=someId&status=done,updated`
 *
 *
 */
export function generateHttpParams(paramsObject: Record<string, never>): HttpParams {
  return updateHttpParams(paramsObject, new HttpParams());
}

function convertToString(el: boolean | string | number | string[] | number[]): string {
  if (Array.isArray(el)) {
    return el.join(',');
  }

  return el.toString();
}

export function prepareParamsForRequest(
  params: IListFilter,
  joinArraysValues = false
): Record<string, string | readonly string[]> {
  const newParams: Record<string, string | readonly string[]> = {};
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const val = params[key];

      if (val !== null && val !== undefined) {
        newParams[key] =
          Array.isArray(val) && !joinArraysValues ? val.map(el => convertToString(el)) : convertToString(val);
      }
    }
  }

  return newParams;
}
